// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-container {
  width: 3.2rem;
  height: 3rem;
  position: relative;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  border: 1px solid rgb(150, 147, 147);
  background-color: white;
}

.events-table {
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  overflow-x: auto;
}

@media (max-width: 1024px) {
  .events-table {
    font-size: 12px;
  }

  .events-table thead th,
  .events-table tbody td {
    padding: 6px;
  }

  .events-table thead th {
    font-size: 12px;
  }
}

@media (max-width: 1024px) {
  .image-container {
    width: 2.4rem;
    height: 2.2rem;
  }
}

.events-table table {
  border: none;
}

.events-table table th,
.events-table table td {
  border: none;
  text-align: center;
}

.events-table tbody {
  /* border: 6px solid #fff; */
  border-top: 1rem solid #eaedeb;
  tr {
    height: 5rem;
    &:first-child {
      td {
        padding: 0;
        margin: 0;

        &:first-child {
          background-color: #eaedeb;

          div {
            display: flex;
            height: 5rem;
            background: #ffffff;
            align-items: center;
            justify-content: center;
            border-top-left-radius: 10px;
            /* box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
                        margin-left: 2px; */
          }
        }

        &:last-child {
          background-color: #eaedeb;

          div {
            display: flex;
            height: 5rem;
            background: #ffffff;
            align-items: center;
            justify-content: center;
            border-top-right-radius: 10px;
            /* box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
                        margin-left: 2px; */
          }
        }
      }
    }
  }
}

.events-table thead {
  tr {
    th {
      padding: 0;
      margin: 0;
      background-color: #eaedeb;

      div {
        background-color: #d0e9ee;
        height: 100%;
        align-items: center;
        justify-content: center;
        /* box-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px; */
      }

      &:first-child {
        div {
          border-bottom-left-radius: 10px;
          border-top-left-radius: 10px;
          /* box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
                    margin-left: 2px; */
        }
      }

      &:last-child {
        div {
          border-bottom-right-radius: 10px;
          border-top-right-radius: 10px;
          /* box-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px; */
          margin-right: 3px;
        }
      }
    }
  }
}

.events-table thead {
  /* border: 6px solid #d0e9ee; */
  position: sticky;
  top: 0;
  z-index: 100;
}

.events-table tfoot td {
  background: #eaedeb;
  border-bottom: none !important;
}

/* Fix MaterialTable flex layout */
.events-table.MuiPaper-root, .events-table .MuiPaper-root {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}
.events-table .MuiTableContainer-root {
  flex: 1 1 !important;
  overflow-y: auto !important;
}

`, "",{"version":3,"sources":["webpack://./src/components/common/Tables/ViewEventsTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B;IACE,YAAY;IACZ;MACE;QACE,UAAU;QACV,SAAS;;QAET;UACE,yBAAyB;;UAEzB;YACE,aAAa;YACb,YAAY;YACZ,mBAAmB;YACnB,mBAAmB;YACnB,uBAAuB;YACvB,4BAA4B;YAC5B;2CAC+B;UACjC;QACF;;QAEA;UACE,yBAAyB;;UAEzB;YACE,aAAa;YACb,YAAY;YACZ,mBAAmB;YACnB,mBAAmB;YACnB,uBAAuB;YACvB,6BAA6B;YAC7B;2CAC+B;UACjC;QACF;MACF;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE,UAAU;MACV,SAAS;MACT,yBAAyB;;MAEzB;QACE,yBAAyB;QACzB,YAAY;QACZ,mBAAmB;QACnB,uBAAuB;QACvB,gDAAgD;MAClD;;MAEA;QACE;UACE,+BAA+B;UAC/B,4BAA4B;UAC5B;uCAC6B;QAC/B;MACF;;MAEA;QACE;UACE,gCAAgC;UAChC,6BAA6B;UAC7B,gDAAgD;UAChD,iBAAiB;QACnB;MACF;IACF;EACF;AACF;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE,wBAAwB;EACxB,iCAAiC;EACjC,uBAAuB;AACzB;AACA;EACE,oBAAkB;EAClB,2BAA2B;AAC7B","sourcesContent":[".image-container {\n  width: 3.2rem;\n  height: 3rem;\n  position: relative;\n}\n\n.image-placeholder {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  border: 1px solid rgb(150, 147, 147);\n  background-color: white;\n}\n\n.events-table {\n  width: 100%;\n  padding: 0;\n  box-sizing: border-box;\n  overflow-x: auto;\n}\n\n@media (max-width: 1024px) {\n  .events-table {\n    font-size: 12px;\n  }\n\n  .events-table thead th,\n  .events-table tbody td {\n    padding: 6px;\n  }\n\n  .events-table thead th {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .image-container {\n    width: 2.4rem;\n    height: 2.2rem;\n  }\n}\n\n.events-table table {\n  border: none;\n}\n\n.events-table table th,\n.events-table table td {\n  border: none;\n  text-align: center;\n}\n\n.events-table tbody {\n  /* border: 6px solid #fff; */\n  border-top: 1rem solid #eaedeb;\n  tr {\n    height: 5rem;\n    &:first-child {\n      td {\n        padding: 0;\n        margin: 0;\n\n        &:first-child {\n          background-color: #eaedeb;\n\n          div {\n            display: flex;\n            height: 5rem;\n            background: #ffffff;\n            align-items: center;\n            justify-content: center;\n            border-top-left-radius: 10px;\n            /* box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;\n                        margin-left: 2px; */\n          }\n        }\n\n        &:last-child {\n          background-color: #eaedeb;\n\n          div {\n            display: flex;\n            height: 5rem;\n            background: #ffffff;\n            align-items: center;\n            justify-content: center;\n            border-top-right-radius: 10px;\n            /* box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;\n                        margin-left: 2px; */\n          }\n        }\n      }\n    }\n  }\n}\n\n.events-table thead {\n  tr {\n    th {\n      padding: 0;\n      margin: 0;\n      background-color: #eaedeb;\n\n      div {\n        background-color: #d0e9ee;\n        height: 100%;\n        align-items: center;\n        justify-content: center;\n        /* box-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px; */\n      }\n\n      &:first-child {\n        div {\n          border-bottom-left-radius: 10px;\n          border-top-left-radius: 10px;\n          /* box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;\n                    margin-left: 2px; */\n        }\n      }\n\n      &:last-child {\n        div {\n          border-bottom-right-radius: 10px;\n          border-top-right-radius: 10px;\n          /* box-shadow: rgba(0, 0, 0, 0.2) 2px 2px 4px; */\n          margin-right: 3px;\n        }\n      }\n    }\n  }\n}\n\n.events-table thead {\n  /* border: 6px solid #d0e9ee; */\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.events-table tfoot td {\n  background: #eaedeb;\n  border-bottom: none !important;\n}\n\n/* Fix MaterialTable flex layout */\n.events-table.MuiPaper-root, .events-table .MuiPaper-root {\n  display: flex !important;\n  flex-direction: column !important;\n  height: 100% !important;\n}\n.events-table .MuiTableContainer-root {\n  flex: 1 !important;\n  overflow-y: auto !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
